module.exports = __webpack_public_path__ + "img/client_logo_alpha.8cdfdda0.webp";